import gql from 'graphql-tag'

import { ITour, IToursWhereInput } from './common'

// Good practice numero 1 in programare - keep local code in local scope. Move it to the parent scope only when it's shared
export const ToursFragment = gql`
	fragment ToursFragment on ToursConnection {
		edges {
            node {
              id
              title
              slug
              image
              country {
                  id
                  slug
              }
              location {
                  id
                  regionSlug
                  citySlug
              }
            }
            cursor
        }
        pageInfo {
            hasNextPage
        }
        total
	}
`

export const ToursQuery = gql`
	query tours($where: TourWhereInput!, $order: TourOrderInput, $first: Int!, $after: String) {
		tours(where: $where, order: $order, first: $first, after: $after) {
			...ToursFragment
		}
	}
	${ToursFragment}
`

export interface IToursQueryVariables {
    where: IToursWhereInput
    order: IToursQueryOrderInput
    first: number
    after?: string
}

export enum TourOrderByEnum {
    date,
    title,
    views
}

export enum OrderByDirectionEnum {
    asc,
    desc
}

export interface IToursQueryOrderInput {
    by: String
    direction: String
}

export interface IToursQueryData {
    tours: IToursConnection
}

export interface IToursConnection {
    edges: Array<ITourEdge>
    pageInfo: IPageInfo
    total: number
}

export interface IPageInfo {
    hasNextPage: boolean
}

export interface ITourEdge {
    node: ITour
    cursor: string
}